import { Injectable } from '@angular/core';
import introJs from 'intro.js';
import { IntroJs } from 'intro.js/src/intro';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
    providedIn: 'root'
})
export class IntroTourService {


    private intro: IntroJs;

    constructor(private cookies: CookieService) {
        this.intro = introJs();
    }


    fnTourStatusCheck(tourName) {
        const ctrl: string = this.cookies.get(tourName);
        if (ctrl == 'true') {
            return false;
        } else {
            return true;
        }
    }

    fnStartTour(tourName: string, steps: Array<any>, onExitCallback?: () => void): void {
        this.intro.setOptions({
            steps,
            isActive: true,
            nextLabel: 'Go Next >',
            prevLabel: '< Back',
            doneLabel: 'Done!',
            hidePrev: true,
            tooltipClass: 'new-tooltip',
            exitOnEsc: false,
            exitOnOverlayClick: false,
            keyboardNavigation: false,
            showButtons: true,
            showBullets: true,
            showProgress: false,
            scrollToElement: true,
            scrollTo: 'element',
            scrollPadding: 0,
            overlayOpacity: .1,
            autoPosition: true,
            disableInteraction: true,
            // dontShowAgain: false,
        });

        this.intro.start();

        this.intro.oncomplete(() => {
            this.cookies.set(tourName, 'true');
        });

        if (onExitCallback) {
            this.intro.onexit(onExitCallback);
        }

    }

}